import { atom } from "recoil";

export const user_state = atom({
  key: 'user_state',
  default: null,
})
